export class BuilderMapping {
  id: string;
  builderName: string;
  subsidiaryId: string[];
  subsidiaryName: string[];
  status: string;
}

export class BuilderMappingOne {
  id: string;
  builderName: string;
  subsidiaryId: string;
  _subsidiaryName: string;
  subsidiaryName: string;
  status: string;
  recUpdatedBy: string;
  recCreatedBy: string;
  recCreatedDate: string;
  recUpdatedDate: string;

}
